import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  BadRequestError,
  Conflict,
  Forbidden,
  InvalidCredentialsError,
  NotFound,
  UnexpectedError,
} from '~/domain/errors';
import { GetProfessionalOnDuty } from '~/domain/usecases/duty/remote';
import '~/infra/global/variables';

export class RemoteGetProfessionalOnDuty implements GetProfessionalOnDuty {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetProfessionalOnDuty.Model>;

  constructor(url: string, httClient: HttpClient<GetProfessionalOnDuty.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetProfessionalOnDuty.Params,
  ): Promise<GetProfessionalOnDuty.Model> => {
    const makeQueryString = () => {
      const { query } = params;
      return Object.entries(query ?? {})
        .map(([key, value]) => {
          return `${key}=${value}`;
        })
        .join('&');
    };

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${
        params.onCallId
      }/specialists/list?${makeQueryString()}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.conflict:
        throw new Conflict();
      default:
        throw new UnexpectedError();
    }
  };
}
